import React, { useState } from 'react'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useFetchList } from 'store'

import styles from './Dialog.module.sass'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import { useDeepCompareEffect } from 'react-use'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import { translateErrorMessage } from 'hooks/useSubmitTask'

const DocumentDialog = (props) => {
	const { className, data, resolve, dismiss } = props
	const { i18n, expireSession, pushNotification } = useGlobal()
	const [docType, setDocType] = useState(null)
	const [description, setDescription] = useState('')
	const [file, setFile] = useState(null)
	const [, setTemplate] = useState(null)
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const {
		contents: [documentTypes = []],
	} = useFetchList(
		['/metadata/document_types'],
		[
			(json) => {
				return {
					value: json?.id?.toString(),
					text: json?.documentType?.trim(),
				}
			},
		]
	)

	useDeepCompareEffect(() => {
		if (documentTypes) {
			setDocType(documentTypes[0]?.value)
		}
	}, [documentTypes])

	const handleSubmit = (e) => {
		e.preventDefault()
		if (submitting) {
			return
		}
		const url = `${API_URL}/api/clinical_processes/${data?.processId}/upload_document`
		const formData = new FormData()
		formData.append('documentTypeId', docType)
		formData.append('observation', description)
		if (file) {
			formData.append('file', file, file?.name)
		}
		setError(null)
		setSubmitting(true)
		fetch(
			url,
			fetchOptions({
				method: 'POST',
				body: formData,
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				resolve && resolve()
				pushNotification(
					undefined,
					'success',
					i18n`Document inserted successfully!`
				)
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}

				const errorMessage = translateErrorMessage(err, i18n)

				setSubmitting(false)
				setError([errorMessage])
			})
	}

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<form
				id={'form_document'}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
				disabled={submitting}
			>
				<fieldset>
					<small className={styles['dialog-title']}>
						{i18n`Enter your document`}
					</small>
					<Dropdown
						className={styles['dropdown']}
						placeholder={i18n`Document Type`}
						value={docType}
						options={documentTypes}
						optionsAlign='right'
						searchable={true}
						onChange={(e) => {
							setDocType(e.target.value)
						}}
					/>
					<TextInput
						placeholder={i18n`Description`}
						value={description}
						multiline
						noResize
						rows='3'
						onChange={(e) => {
							setTemplate(null)
							setDescription(e.target.value)
						}}
					/>
					<label className={styles['file-chooser']}>
						<HStack
							align='center'
							justify='space-between'
							gap='xsmall'
						>
							<VStack>
								<small>
									<strong>{i18n`Attach a file`}</strong>
								</small>
								<input
									type='file'
									required
									onChange={(e) => {
										setFile(e.target.files[0])
									}}
								/>
								<small className={styles['filename']}>
									{file?.name}
								</small>
							</VStack>
							<span className={styles['file-chooser-button']}>
								<small>{i18n`Browse`}</small>
							</span>
						</HStack>
					</label>
				</fieldset>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={`form_document`} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default DocumentDialog
